
export default function Logo () {
  return (
    <div className='flex'>
      <img
        src={process.env.PUBLIC_URL + 'images/my_logo_black.png'} alt='my_logo'
        className='
      2xl:w-[200px] 2xl:h-[200px]
      xl:w-[150px] xl:h-[150px]
      lg:w-[100px] lg:h-[100px]
      md:w-[90px] md:h-[90px]
      sm:w-[85px] sm:h-[85px]
      min-[300px]:w-[80px] min-[400px]:h-[35px]'
      />
    </div>
  )
}
